// extracted by mini-css-extract-plugin
export default {"PhoneConfirmConatiner":"phoneConfirm_PhoneConfirmConatiner__Mcll4","notificationContainer":"phoneConfirm_notificationContainer__j0FFl","action_btn":"phoneConfirm_action_btn__q-wLl"};